
















import { defineComponent } from '@nuxtjs/composition-api';
import VaimoIcon from 'atoms/VaimoIcon.vue';

export default defineComponent({
  name: 'SwiperNext',
  components: {
    VaimoIcon
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Next slide'
    },
    size: {
      type: Number,
      default: 24
    }
  },
  emits: ['navigation:click']
});
